<script>
/**
 * 再資源化等処理情報 編集モーダル
 * emit: registered 登録完了後に発火するイベント.登録内容を引数で戻す
 */
import {mapActions} from "vuex";
import ChooseRecycleDisposalPatternBotton from "@/driver/components/ChooseRecycleDisposalPatternBotton.vue";

export default {
  name: "EditRecycleDisposalReportDialog",
  components: {ChooseRecycleDisposalPatternBotton},
  mixins: [],
  props: {
    manifestId: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      openModal: false,
      form: null,
      recycleDisposerDisposalMethods: [],
      disposalStandardQuantityTypes: [
        { value: 'fixed_quantity', text: '確定数量' },
        { value: 'waste_quantity', text: '廃棄物の数量' },
        { value: 'transport_quantity', text: '運搬業者の数量' },
        { value: 'disposal_quantity', text: '処分数量' },
      ],
      headers: [
        { value: "level", text: "工程", width: "5%" },
        { value: "disposer", text: "処分事業者\r\n処分事業場\r\n住所", width: "17%" },
        { value: "report_before_disposal_weight", text: "処分前重量", width: "10%" },
        { value: "disposal_method", text: "処分方法", width: "15%" },
        { value: "report_after_disposal_weight", text: "処理後重量", width: "10%" },
        { value: "recycle_disposed_item", text: "処理後物の大分類\r\n処理後物の種類", width: "15%", show_final_disposal_label: true },
        { value: "comment", text: "備考", width: "18%" },
      ],
      customMessages: {
        double: '数量は半角数字のみ使用できます'
      },
    }
  },
  computed: {
    recyclePatternDialogCondition () {
      return {
        item_id: this.form?.item_id,
        disposer_id: this.form?.disposer_id,
        disposer_location_id: this.form?.disposer_location_id,
        disposer_location_code: this.form?.disposer_location_code,
        final_disposal: false,
      }
    },
    isDisposalInfoPrivateRequired () {
      return this.form?.disposal_report_type === 'last_report' && this.form?.manifest_type !== 'paper_form'
    },
    disposalQuantityRules () {
      let baseRules = 'double|max_value:9999999999.999|quantityWithDecimal:10,3'
      // 報告区分＝中間　AND　処分場処理方法が未選択の場合：重量はNULL 又は　0以上
      if (this.form?.disposal_report_type === 'middle_report' && this.form?.recycle_disposer_disposal_method_id === null) {
        baseRules += '|min_value:0'
        // 報告区分＝最終　AND 処分場処理方法が未選択　AND マニ区分＝紙の場合：重量はNULL 又は　0以上
      } else if (this.form?.disposal_report_type === 'last_report' && this.form?.manifest_type === 'paper_form' && this.form?.recycle_disposer_disposal_method_id === null) {
        baseRules += '|min_value:0'
        //上記以外の場合：重量は0.001以上
      } else {
        baseRules += '|min_value:0.001'
      }
      return baseRules;
    },
    recycleDisposalMiddleReportRules () {
      const targetList = this.form?.manifest_recycle_disposal_middle_reports
      const rules = {}
      // 処分場処理方法が未選択の場合：一覧は空になるため、件数のチェックは行わない
      if (this.form?.recycle_disposer_disposal_method_id !== null && this.form?.recycle_disposer_disposal_method_id !== undefined) {
        rules.pMLength = { targetList: targetList }
      }
      rules.pmFirstBeforeWeightTotalRange = { targetList: targetList, final_disposal_quantity: this.form?.disposal_quantity }
      return rules;
    },
  },
  watch: {
    openModal (newValue) {
      this.form = null;
      if (newValue) {
        this.loadManifest();
      }
    },
    /**
     * 処分場処理方法の監視
     * 空にしたときは RecycleStepTable の洗い替えが走らないため、
     * ここでマニフェスト再資源化処分報告（中間）（manifest_recycle_disposal_middle_reports）を空にする
     * @param newValue { Number }
     */
    'form.recycle_disposer_disposal_method_id' (newValue) {
      if (!this.form) {
        return;
      }
      if (newValue === null || newValue === undefined) {
        this.form.manifest_recycle_disposal_middle_reports = [];
      }
    },
  },
  created() {},
  methods: {

    /**
     * 処分場処理方法検索
     */
    ...mapActions('DriverMasterSearchRecycleDisposerDisposalMethod', {
      fetchRecycleDisposerDisposalMethods: 'index',
    }),

    /**
     * 初期情報取得
     * 編集内容登録
     */
    ...mapActions("DriverManifestManagementManifestRecycleDisposalReport", {
      fetchEditManifest: "edit",
      updateManifest: "update"
    }),

    ...mapActions('DriverManifestDisposalReport', {
      fetchDisposalQuantity: 'disposalQuantity',
    }),

    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClick () {
      this.openModal = false;
    },

    /**
     * 更新ボタン クリックイベント
     */
    updateButtonClick () {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          this.registerMiddleReports();
        }
      })
    },

    /**
     * 基準重量変更イベント.
     */
    onStandardQuantityChange () {

      const selectedType = this.form.disposal_standard_quantity_type;

      if (selectedType === 'disposal_quantity') {

        const params = {
          manifest_id: this.manifestId,
          disposal_report_amount: this.form?.disposal_report_amount,
          disposal_report_amount_unit_id: this.form?.disposal_report_amount_unit_id,
        }
        // disposal_quantityを取得して設定する
        this.fetchDisposalQuantity({ params }).then((content) => {
          this.$set(this.form, 'disposal_quantity', content?.disposal_quantity)
        }).catch(() => {
          this.$set(this.form, 'disposal_quantity', null)
        })
        return
      }

      let convertedKey = null

      if (selectedType === 'fixed_quantity') {
        convertedKey = 'conversion_fixed_quantity'
      } else if (selectedType === 'waste_quantity') {
        convertedKey = 'conversion_waste_quantity'
      } else if (selectedType === 'transport_quantity') {
        convertedKey = 'conversion_transport_quantity'
      }

      this.$set(this.form, 'disposal_quantity',  this.form?.[convertedKey])
    },

    /**
     * 処分場処理方法モーダル コールバック
     * @param item
     */
    choseRecycleDisposalPatternCallback (item) {
      this.form.recycle_disposer_disposal_method_id = item.pattern.id
    },

    /**
     * 初期表示情報のロード
     */
    loadManifest () {
      this.fetchEditManifest({ id: this.manifestId }).then((content) => {
        this.form = content
        this.loadRecycleDisposerDisposalMethods();
      })
    },

    /**
     * 処分場処理方法リストのロード
     */
    loadRecycleDisposerDisposalMethods() {
      this.fetchRecycleDisposerDisposalMethods({
        ...this.recyclePatternDialogCondition
      }).then((content) => {
        this.recycleDisposerDisposalMethods = content.recycle_disposer_disposal_methods || []
      })
    },

    /**
     * 処分場処理方法詳細のロード
     * @param items
     */
    replaceRecycleDisposerDisposalMethodDetails (items) {
      this.form.manifest_recycle_disposal_middle_reports = items
    },

    /**
     * 登録処理
     */
    registerMiddleReports () {
      const disposal_quantity = (Number(this.form.disposal_quantity) === 0 || isNaN(Number(this.form.disposal_quantity))) ? null : this.form.disposal_quantity
      const params = {
        disposal_standard_quantity_type: this.form.disposal_standard_quantity_type,
        disposal_quantity: disposal_quantity,
        manifest_recycle_disposal_reports: this.form.manifest_recycle_disposal_middle_reports,
      };
      this.updateManifest({ id: this.manifestId, params: params }).then((content) => {
        this.$emit('registered', content)
        this.closeButtonClick();
      });
    },
  },
}
</script>

<template>
<v-dialog
  v-model="openModal"
  persistent
  width="1300"
  @keydown.esc="closeButtonClick"
  @close="closeButtonClick"
>
  <template v-slot:activator="{ on, attrs }">
    <v-btn
      v-bind="attrs"
      v-on="on"
      :disabled="disabled"
      small
    >
      <v-icon small>
        mdi-pencil
      </v-icon>
      &nbsp;編集
    </v-btn>
  </template>
  <validation-observer ref="observer">
    <v-card
      flat
    >
      <v-toolbar flat>
        <v-toolbar-title>再資源化等処理情報の編集</v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text v-if="form">
        <!-- 基準重量・処分場処理方法 -->
        <v-row>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              :class="{ requiredMark: isDisposalInfoPrivateRequired }"
              :rules="isDisposalInfoPrivateRequired ? 'required' : ''"
              name="基準重量"
            >
              <v-select
                v-model="form.disposal_standard_quantity_type"
                :error-messages="errors"
                :items="disposalStandardQuantityTypes"
                clearable
                dense
                hide-details="auto"
                label="基準重量"
                outlined
                persistent-placeholder
                @change="onStandardQuantityChange"
              ></v-select>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              :custom-messages="customMessages"
              :class="{ requiredMark: isDisposalInfoPrivateRequired }"
              name="重量"
              :rules="disposalQuantityRules"
            >
              <v-text-field
                v-model="form.disposal_quantity"
                :error-messages="errors"
                dense
                hide-details="auto"
                label="重量"
                outlined
                persistent-placeholder
                type="number"
                reverse
                @keydown.69.prevent
              >
                <template v-slot:prepend-inner>
                  <span class="mt-1 mr-1">kg</span>
                </template>
              </v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <validation-provider
              v-slot="{ errors }"
              name="処分場処理方法"
            >
              <v-select
                v-model="form.recycle_disposer_disposal_method_id"
                :error-messages="errors"
                :items="recycleDisposerDisposalMethods"
                clearable
                dense
                hide-details="auto"
                label="処分場処理方法"
                outlined
                persistent-placeholder
              >
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on" v-bind="attrs">
                    <v-list-item-content>
                      <template>
                        <div class="d-flex align-center flex-wrap py-1" style="gap: 8px;">
                          <v-chip color="primary" label text-color="white" x-small>処分場処理方法</v-chip>
                          <span class="font-weight-medium">{{ item.pattern_name || item.text }}</span>
                        </div>
                      </template>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-slot:selection="{ item }">
                  {{ item.pattern_name || item.text }}
                </template>
                <template v-slot:append-outer>
                  <choose-recycle-disposal-pattern-botton
                    :fixed-condition="recyclePatternDialogCondition"
                    :final-disposal=false
                    small-button
                    button-caption="選択"
                    only-method
                    @choseRecycleDisposalPatternCallback="choseRecycleDisposalPatternCallback"
                  />
                </template>
              </v-select>
            </validation-provider>
          </v-col>
        </v-row>
        <!-- /基準重量・処分場処理方法 -->

        <v-row>
          <v-col cols="12">
            <validation-provider
              v-slot="{ errors: detailErrors }"
              :rules="recycleDisposalMiddleReportRules"
              name="リスト"
            >
              <div class="hidden">
                <v-input
                  v-model="form"
                  :error-messages="detailErrors"
                  dense
                  outlined
                  readonly
                  hide-details="auto"
                >
                  <template v-slot:message>
                    <div class="ml-2">
                      <p v-for="(message, index) in detailErrors" :key="index">{{ message }}</p>
                    </div>
                  </template>
                </v-input>
              </div>
              <recycle-step-table
                v-if="form?.manifest_recycle_disposal_middle_reports"
                :editable-mode="true"
                :final-disposal-quantity="form.disposal_quantity"
                :headers="headers"
                :pattern-id="form.recycle_disposer_disposal_method_id"
                :pattern-type="`methods`"
                :result-list.sync="form.manifest_recycle_disposal_middle_reports"
                @replace:list="replaceRecycleDisposerDisposalMethodDetails"
              />
            </validation-provider>
          </v-col>
        </v-row>

      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeButtonClick">閉じる</v-btn>
        <v-btn color="primary" @click="updateButtonClick">更新</v-btn>
      </v-card-actions>
    </v-card>
  </validation-observer>
</v-dialog>
</template>

<style scoped lang="scss">

</style>
